import Link from 'next/link';
import { cn } from '@/lib/utils';

interface LogoProps {
  className?: string;
  withSubline?: boolean;
  href?: string;
}

export function Logo({ className, withSubline = true, href = '/' }: LogoProps) {
  return (
    <Link
      href={href}
      className={cn(
        'group flex items-center gap-2 transition-opacity hover:opacity-90',
        className,
      )}
      aria-label="Oro Express Academy — Inicio"
    >
      <div className="relative">
        <svg
          viewBox="0 0 48 48"
          className="h-9 w-9 drop-shadow-[0_0_18px_rgba(201,169,97,0.45)]"
          aria-hidden
        >
          <defs>
            <linearGradient id="oeLogoGold" x1="0" y1="0" x2="1" y2="1">
              <stop offset="0%" stopColor="#9C7F3F" />
              <stop offset="50%" stopColor="#E5C988" />
              <stop offset="100%" stopColor="#C9A961" />
            </linearGradient>
          </defs>
          <rect
            x="6"
            y="14"
            width="36"
            height="20"
            rx="3"
            fill="url(#oeLogoGold)"
            transform="skewX(-12) translate(6 0)"
          />
          <path
            d="M14 18 L34 18 L36 24 L34 30 L14 30 L12 24 Z"
            fill="url(#oeLogoGold)"
            opacity="0.85"
          />
          <text
            x="24"
            y="27.5"
            textAnchor="middle"
            fontFamily="Playfair Display, serif"
            fontSize="11"
            fontWeight="900"
            fill="#050505"
          >
            OE
          </text>
        </svg>
      </div>
      <div className="flex flex-col leading-tight">
        <span className="font-display text-base font-bold tracking-tight text-cream sm:text-lg">
          <span className="text-gold-gradient">Oro Express</span>{' '}
          <span className="text-cream/85">Academy</span>
        </span>
        {withSubline && (
          <span className="text-[10px] tracking-[0.2em] text-cream/45">
            BY ORO EXPRESS
          </span>
        )}
      </div>
    </Link>
  );
}
